import styled from 'styled-components';

const HeaderContainer = styled.div(props => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${props.background};
    padding: 2rem 1rem;
    margin: auto;
`);

const HeaderLogo = styled.img`
    max-height: 60px;
    width: auto;
`;

const HeaderMenu = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 50%;

    @media screen and (max-width: 976px) {
        display: none;
    }
`;

const HeaderLink = styled.a`
    color: #2B292D;
    font-size: 18px;
    text-decoration: none;
    cursor: pointer;

    &:hover {
        font-weight: bold;
    }

    &:active {
        font-weight: bold;
    }
`;

const HeaderButton = styled.button`
    background-color: #FF5E48;
    color: #fff;
    border-radius: 0;
    padding: .5rem 1rem;
    font-size: 16px;
    font-weight: bold;
    border: none;
`;

export { HeaderContainer, HeaderLogo, HeaderMenu, HeaderLink, HeaderButton };